import { FC, useState } from "react";
import ListingFilterComponent from "../../../../../../common/components/listing/filter/listing-filter.component";
import ListingFilterDefinition from "../../../../../../common/components/listing/filter/types/listing-filter-definition";
import useOpen from "../../../../../../common/hooks/use-open";
import OrderOptimizerRailyListingMaximumDelayModalComponent from "../../../../../order-optimizer/raily/listing/maximum-delay-modal/order-optimizer-raily-listing-maximum-delay-modal.component";
import OrderOptimizerRailyListingMaximumHaltingTimeModalComponent from "../../../../../order-optimizer/raily/listing/maximum-halting-time-modal/order-optimizer-raily-listing-maximum-halting-time-modal.component";
import orderDetailsManageDriverAssignmentOptitoolHelper from "./order-details-manage-driver-assignment-optitool-filters.helper";
import OrderDetailsManageDriverAssignmentOptitoolFilter from "./types/order-details-manage-driver-assignment-optitool-filter";
import OrderDetailsManageDriverAssignmentOptitoolFilterType from "./types/order-details-manage-driver-assignment-optitool-filter-type";

type OrderDetailsManageDriverAssignmentOptitoolFiltersProps = {
  filters: OrderDetailsManageDriverAssignmentOptitoolFilter[];
  onFiltersChange: (
    filters: OrderDetailsManageDriverAssignmentOptitoolFilter[],
  ) => void;
};

const OrderDetailsManageDriverAssignmentOptitoolFiltersComponent: FC<
  OrderDetailsManageDriverAssignmentOptitoolFiltersProps
> = (props) => {
  const maximumDelayModal = useOpen();
  const maximumHaltingTimeModal = useOpen();

  const [maximumDelayValue, setMaximumDelayValue] = useState<number>(0);
  const [maximumHaltingTimeValue, setMaximumHaltingTimeValue] =
    useState<number>(0);

  const confirmMaximumDelay = () => {
    const newFilter: OrderDetailsManageDriverAssignmentOptitoolFilter = {
      type: OrderDetailsManageDriverAssignmentOptitoolFilterType.MAXIMUM_DELAY,
      value: maximumDelayValue,
    };
    props.onFiltersChange([
      ...props.filters.filter(
        (filter) =>
          filter.type !==
          OrderDetailsManageDriverAssignmentOptitoolFilterType.MAXIMUM_DELAY,
      ),
      newFilter,
    ]);

    maximumDelayModal.close();
  };

  const confirmMaximumHaltingTime = () => {
    const newFilter: OrderDetailsManageDriverAssignmentOptitoolFilter = {
      type: OrderDetailsManageDriverAssignmentOptitoolFilterType.MAXIMUM_HALTING_TIME,
      value: maximumHaltingTimeValue,
    };
    props.onFiltersChange([
      ...props.filters.filter(
        (filter) =>
          filter.type !==
          OrderDetailsManageDriverAssignmentOptitoolFilterType.MAXIMUM_HALTING_TIME,
      ),
      newFilter,
    ]);

    maximumHaltingTimeModal.close();
  };

  const openMaximumDelayModal = () => {
    setMaximumDelayValue(0);
    maximumDelayModal.open();
  };

  const closeMaximumDelayModal = () => {
    maximumDelayModal.close();
    setMaximumDelayValue(0);
  };

  const openMaximumHaltingTimeModal = () => {
    setMaximumHaltingTimeValue(0);
    maximumHaltingTimeModal.open();
  };

  const closeMaximumHaltingTimeModal = () => {
    maximumHaltingTimeModal.close();
    setMaximumHaltingTimeValue(0);
  };

  const filterDefinition: ListingFilterDefinition<OrderDetailsManageDriverAssignmentOptitoolFilter> =
    orderDetailsManageDriverAssignmentOptitoolHelper().getFilterDefinition(
      openMaximumDelayModal,
      openMaximumHaltingTimeModal,
    );

  return (
    <div className="order_optimizer_raily_listing_filter">
      <div className="order_optimizer_raily_listing_filter__input_wrapper">
        <ListingFilterComponent
          appliedFilters={props.filters}
          filterDefinition={filterDefinition}
          onFiltersChange={(appliedFilters) => {
            props.onFiltersChange(
              appliedFilters as OrderDetailsManageDriverAssignmentOptitoolFilter[],
            );
          }}
          sortDefinition={{ options: [] }}
          appliedSortKey=""
          onSortKeyChange={() => {}}
          menuPlacement="top"
        />
      </div>
      <OrderOptimizerRailyListingMaximumDelayModalComponent
        isOpen={maximumDelayModal.isOpen}
        maximumDelayValue={maximumDelayValue}
        onCloseClick={closeMaximumDelayModal}
        onSuccessClick={confirmMaximumDelay}
        setMaximumDelayValue={setMaximumDelayValue}
      />
      <OrderOptimizerRailyListingMaximumHaltingTimeModalComponent
        isOpen={maximumHaltingTimeModal.isOpen}
        maximumHaltingTimeValue={maximumHaltingTimeValue}
        onCloseClick={closeMaximumHaltingTimeModal}
        onSuccessClick={confirmMaximumHaltingTime}
        setMaximumHaltingTimeValue={setMaximumHaltingTimeValue}
      />
    </div>
  );
};

export default OrderDetailsManageDriverAssignmentOptitoolFiltersComponent;
